import { Image } from '../LogoImage'

export function backgroundBannerImage(image: Image) {
  switch (image.as) {
    case 'svg':
      return `no-repeat ${image.color} url("data:image/svg+xml;utf8,${encodeURIComponent(image.src)}")`
    case 'img':
      return `no-repeat ${image.color} url(${image.src})`
    default:
      return 'none'
  }
}
